import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import {
  IAlineacionBody,
  ICalificacionCargada,
  ICalificacionesAlineacion,
  ICalificacionesBlackboard,
  IConfiguracionPonderacion,
  ICursosBlackboard,
} from "src/app/interfaces/integracion-blackboard";
import { IntegracionesBlackboardService } from "src/app/services/integraciones-blackboard/integraciones-blackboard.service";

interface FiltroSeccion {
  anyo: number;
  periodoId: number;
  sedeId: number;
  docenteId: string;
  seccionId: number;
  asignaturaId: number;
  ponderacionId: number;
  nombreSeccion: string;
  nombreAsignatura: string;
  nombreAsignaturaBB: string;
  nombreSeccionBB: string;
  bbId: string;
  instanciaBBId: number | null;
}
interface EvaluacionDnD {
  nombre: string;
  id: string;
  categoria: string | null;
  puntaje: number;
}
@Component({
  selector: "app-alineacion-blackboard",
  templateUrl: "./alineacion-blackboard.component.html",
  styleUrls: ["./alineacion-blackboard.component.scss"],
})
export class AlineacionBlackboardComponent implements OnInit {
  vista = "";
  //drag and drop

  pruebas = [];
  evaluaciones: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];
  evaluacionesAsignadas: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];
  listaCompletaEvaluaciones: {
    evaluacion: ICalificacionesBlackboard[];
  }[] = [];
  evaluacionesCargadas: ICalificacionCargada[] = [];

  deshabilitado = true;
  mostrarAlerta = false;
  nColumnas = 0;

  idAlineacion = 0;

  filtrosSeccion: FiltroSeccion = {} as FiltroSeccion;

  datosPonderacion: any = {};

  routerData: any = {};
  filtros: any = {};

  mensajeError: Array<string> = [];
  seccionEditable = false;
  seccionIdEditar = "";
  estadoHabilitada = false;

  @ViewChild("listaContainers") listaContainers!: ElementRef;
  @ViewChild("titulosContainer") titulosContainer!: ElementRef;

  constructor(
    private readonly _router: Router,
    private readonly _integracionService: IntegracionesBlackboardService
  ) {
    this.routerData =
      this._router.getCurrentNavigation()?.extras?.state?.["data"];
    console.log(this.routerData);
    if (this.routerData) {
      this.idAlineacion = this.routerData.idAlineacion;
      this.vista = this.routerData.estado;
      this.filtrosSeccion = this.routerData.datosSeccion;
      this.filtros = this.routerData.filtros;
      this.seccionEditable = this.routerData.editable;
    } else {
      this._router.navigate(["/portal-calificacion"]);
    }
  }

  ngOnInit() {
    if (this.vista === "Validar") this.flujoConfirmar();
    else if (this.vista === "Configurar" || this.vista === "Habilitada")
      this.flujoConfigurar();
  }
  async flujoConfigurar() {
    try {
      await this.getAsignaturaBBInfo();
      await this.getCalificacionesBB();
      await this.getCalificacionesPDC();
      if (this.vista === "Habilitada") await this.getAlinecionDocente();
      await this.rellenarListas();
      await this.setEvaluacionesAsignadas();
      this.deshabilitado = this.vista === "Habilitada";
    } catch {
      this.volverAsignaturasPorPeriodo();
    }
  }
  async flujoConfirmar() {
    try {
      await this.getAlineacion();
      await this.getAsignaturaBBInfo();
      await this.getCalificacionesBB();
      await this.getCalificacionesPDC();
      await this.rellenarListas();
      await this.setEvaluacionesAsignadas();
    } catch {
      this.volverAsignaturasPorPeriodo();
    }
  }
  async getAlinecionDocente(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._integracionService
        .obtenerCalificacionesAlineacion(
          this.filtrosSeccion.anyo,
          this.filtrosSeccion.periodoId,
          this.filtrosSeccion.asignaturaId,
          this.filtrosSeccion.sedeId,
          this.filtrosSeccion.seccionId
        )
        .subscribe({
          next: (res: ICalificacionesAlineacion) => {
            if (res.error && res.columnas.length === 0) {
              setTimeout(() => {
                document.getElementById("modal-service-error-btn")?.click();
              }, 300);
              reject(new Error(res.error.mensaje));
            } else {
              this.deshabilitado = true;
              res.columnas.forEach((evaluacion) => {
                const calificacionDocente = this.buscarCalificacion(evaluacion);

                const calificacionTemporal = {
                  bbColumnaId: evaluacion.bbColumnaId,
                  detPonderacionId: calificacionDocente[0].detPonderacionId,
                  nombreColumnaBb: evaluacion.nombreColumnaBB,
                };
                this.evaluacionesCargadas.push(calificacionTemporal);
              });
              resolve();
            }
          },
        });
    });
  }
  buscarCalificacion(evaluacion: any) {
    const calificacionDocente = this.datosPonderacion.calificaciones.filter(
      (calificacion: any) =>
        calificacion.nroNota === evaluacion.nroNota &&
        calificacion.tipo === evaluacion.tipoNota
    );
    return calificacionDocente;
  }
  async getAsignaturaBBInfo(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._integracionService
        .getBuscarCursoBlackboard(
          String(this.filtrosSeccion.seccionId),
          String(this.filtrosSeccion.instanciaBBId)
        )
        .subscribe({
          next: (res: ICursosBlackboard) => {
            this.filtrosSeccion.nombreAsignaturaBB = res.cursoId;
            this.filtrosSeccion.nombreSeccionBB = res.nombre;
            if (this.vista === "Configurar" || this.vista === "Habilitada") {
              this.filtrosSeccion.bbId = res.id;
            }
            this.seccionIdEditar = res.id;
            

            resolve();
          },
          error: (error) => {
            const divContent = document.getElementById(
              "modal-service-error-mensaje"
            );

            if (divContent) {
              divContent.innerHTML =
                "<p>No se encontró el curso en Blackboard. Verifique el curso y vuelva a intentarlo.</p>";
            }
            reject(new Error(error));
          },
        });
    });
  }
  async getCalificacionesPDC(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._integracionService
        .getConfiguracionPonderacion(
          Number(this.filtrosSeccion.anyo),
          Number(this.filtrosSeccion.periodoId),
          Number(this.filtrosSeccion.asignaturaId),
          Number(this.filtrosSeccion.sedeId),
          Number(this.filtrosSeccion.seccionId)
        )
        .subscribe({
          next: (res: IConfiguracionPonderacion) => {
            if (res.error) {
              this.mostrarAlerta = true;
            } else {
              let calificaciones: Array<any> = [];
              res.notasParciales.forEach(({ tipo, ...nota }: any) =>
                calificaciones.push({ tipo: "CP", ...nota })
              );

              res.examenes.forEach(({ tipo, ...nota }: any) =>
                calificaciones.push({ tipo: "CE", ...nota })
              );

              this.datosPonderacion = {
                calificaciones: calificaciones,
                ponderacionId: res.ponderacionBaseId,
                valor: res.valor,
              };
              this.pruebas = this.datosPonderacion.calificaciones.map(
                ({ tipo, nroNota, porcentaje }: any) =>
                  `${tipo}${nroNota} (${porcentaje}%)`
              );
              resolve();
            }
          },
          error: (error) => {
            reject(new Error(error));
          },
        });
    });
  }
  async getCalificacionesBB(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._integracionService
        .getCalificacionesBlackboard(
          String(this.filtrosSeccion.instanciaBBId),
          this.filtrosSeccion.bbId
        )
        .subscribe({
          next: (res: ICalificacionesBlackboard[]) => {
            if (res.length > 0) {
              res.forEach((evaluacion: ICalificacionesBlackboard) => {
                this.evaluaciones.push({ evaluacion: [evaluacion] });
              });

              resolve();
            }
          },
          error: (error) => {
            reject(new Error(error));
          },
        });
    });
  }
  async setEvaluacionesAsignadas(): Promise<void> {
    let listaEvaluaciones: {
      [key: number]: { evaluacion: ICalificacionesBlackboard[] };
    } = {};
    this.evaluacionesCargadas.forEach((evaluacion: ICalificacionCargada) => {
      const evaluacionAsignada = this.evaluaciones.filter(
        (evaluacionBB) =>
          evaluacionBB.evaluacion[0].id === evaluacion.bbColumnaId
      );
      if (evaluacionAsignada.length != 0) {

        listaEvaluaciones[evaluacion.detPonderacionId] = evaluacionAsignada[0];
        const indexEliminar = this.evaluaciones.findIndex(
          (evaluacionBB) =>
            evaluacionBB.evaluacion[0].id === evaluacion.bbColumnaId
        );
        this.evaluaciones.splice(indexEliminar, 1);
        this.evaluaciones.push({
          evaluacion: [
            {
              id: "",
              categoria: "",
              puntaje: 0,
              nombre: "",
            },
          ],
        });
  
        this.listaCompletaEvaluaciones = this.listaCompletaEvaluaciones.filter(
          (evaluacion) =>
            evaluacion.evaluacion[0].id !== evaluacionAsignada[0].evaluacion[0].id
        );
        this.listaCompletaEvaluaciones.push({
          evaluacion: [
            {
              id: "",
              categoria: "",
              puntaje: 0,
              nombre: "",
            },
          ],
        });
      }
    });
    const listaEvaluacionesKey = Object.keys(listaEvaluaciones);
    listaEvaluacionesKey.forEach((key: any) => {
      const ponderacionIndex = this.datosPonderacion.calificaciones.findIndex(
        (ponderacion: any) => ponderacion.detPonderacionId == key
      );
      if (ponderacionIndex !== -1) {
        this.listaCompletaEvaluaciones[
          this.evaluaciones.length + ponderacionIndex
        ] = listaEvaluaciones[key];
        this.evaluacionesAsignadas[ponderacionIndex] = listaEvaluaciones[key];
      }
    });
    return new Promise((resolve) => resolve());
  }
  async rellenarListas(): Promise<void> {
    this.listaCompletaEvaluaciones = [];

    this.evaluaciones.forEach((evaluacion) =>
      this.listaCompletaEvaluaciones.push(evaluacion)
    );

    this.evaluacionesAsignadas = this.pruebas.map(() => ({
      evaluacion: [{ nombre: "", puntaje: 0, categoria: "", id: "" }],
    }));
    this.evaluacionesAsignadas.forEach((evaluacion) =>
      this.listaCompletaEvaluaciones.push(evaluacion)
    );
    return new Promise((resolve) => resolve());
  }
  async getAlineacion(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._integracionService
        .getAlineacionDocente(String(this.idAlineacion))
        .subscribe({
          next: (res: any) => {
            this.filtrosSeccion.bbId = res.bbId;
            this.filtrosSeccion.instanciaBBId = res.instanciaBbId;
            this.evaluacionesCargadas = res.columnas;

            resolve();
          },
          error: (error) => {
            reject(new Error(error.message));
          },
        });
    });
  }

  //drag and drop
  get connectedDropLists() {
    let dropLists = this.evaluaciones.map((_, i) => `cdk-drop-list-${i}`);
    this.evaluacionesAsignadas.forEach((_, i) => {
      dropLists.push(`cdk-drop-list-${i + this.evaluaciones.length}`);
    });
    return dropLists;
  }

  drop(event: CdkDragDrop<EvaluacionDnD[]>, listIndex: number, sort?: string) {
    const previousListIndex = this.listaCompletaEvaluaciones.findIndex(
      (list) => list.evaluacion === event.previousContainer.data
    );
    const targetList = this.listaCompletaEvaluaciones[listIndex];
    const previousList = this.listaCompletaEvaluaciones[previousListIndex];
    if (previousList !== targetList) {
      // Intercambiar la evaluacion entre las listas si la lista objetivo ya tiene una evaluacion
      const targetEvaluacion = targetList.evaluacion[0]; // La evaluacion en la lista objetivo (si existe)
      const draggedEvaluacion = previousList.evaluacion[0]; // La evaluacion que se esta arrastrando
      // Mover la evaluacion arrastrada a la lista objetivo
      if (targetList.evaluacion.length > 0) {
        // Intercambiar evaluaciones: transferir la evaluacion de la lista objetivo de regreso a la lista anterior
        previousList.evaluacion = [targetEvaluacion];
      } else {
        // Si la lista objetivo estaba vacia, solo limpiar la lista anterior
        previousList.evaluacion = [];
      }

      // Establecer la evaluacion arrastrada en la lista objetivo
      targetList.evaluacion = [draggedEvaluacion];

      if (sort === "evaluacionesSort") {
        this.sortListas(this.evaluaciones);
        //ordenar lista completa pero solo hasta el largo de lista evaluaciones
        this.listaCompletaEvaluaciones = this.sortParcial(
          this.listaCompletaEvaluaciones,
          this.evaluaciones.length
        );
      }
    }
  }
  sortParcial(arreglo: Array<any>, index: number) {
    let sortedPart = this.sortListas(arreglo.slice(0, index));
    let unsortedPart = arreglo.slice(index);

    return [...sortedPart, ...unsortedPart];
  }
  sortListas(arreglo: Array<any>) {
    return arreglo.sort((a, b) => {
      if (a.evaluacion[0].nombre !== "" && b.evaluacion[0].nombre === "")
        return -1;
      if (a.evaluacion[0].nombre === "" && b.evaluacion[0].nombre !== "")
        return 1;
      return 0;
    });
  }

  deshabilitarBtnCrear(): boolean {
    return (
      this.evaluacionesAsignadas.filter(
        (evaluacion) => evaluacion.evaluacion[0].nombre !== ""
      ).length === 0
    );
  }
  async habilitarEdicion() {
    if (this.vista === 'Habilitada') this.estadoHabilitada = true;
    this.vista = "Editar";
    this.deshabilitado = false;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.listaCompletaEvaluaciones = [];
    this.evaluaciones = [];
    this.evaluacionesAsignadas = [];
    try {
      await this.getEvaluacionesSeccion();
      console.log("fin getEvaluacionesSeccion");
      await this.rellenarListas();
      console.log("fin rellenarListas");
    } catch(error) {
      
      this.volverAsignaturasPorPeriodo();
    }
    
  }
  /* descartarCambios() {
    this.vista = "Validar";
    this.deshabilitado = true;
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.listaCompletaEvaluaciones = [];
    this.evaluaciones = [];
    this.evaluacionesAsignadas = [];
    this.ngOnInit();
  } */
  guardarAlineacion() {
    const body: IAlineacionBody = {
      alineacionId: this.idAlineacion,
      instanciaBBId: this.filtrosSeccion.instanciaBBId ?? 0,
      ponderacionId: this.filtrosSeccion.ponderacionId,
      seccionId: this.filtrosSeccion.seccionId,
    };
    const data = {
      configuracion: {
        anyo: this.filtrosSeccion.anyo,
        periodoId: this.filtrosSeccion.periodoId,
        sedeId: this.filtrosSeccion.sedeId,
        docenteId: this.filtrosSeccion.docenteId,
        seccionId: this.filtrosSeccion.seccionId,
        asignaturaId: this.filtrosSeccion.asignaturaId,
        ponderacionId: this.filtrosSeccion.ponderacionId,
      },
      resultadoServicio: false,
      desdeIntegracion: true,
      filtros: this.filtros,
    };
    switch (this.vista) {
      case "Configurar":
        this.crearAlineacion(data);
        break;
      case 'Validar':
        this.confirmarAlineacion(body, data);
        break;
      case 'Editar':
        if (!this.estadoHabilitada) {
          this.crearAlineacion(data);
          break;
        } else {
          this.editarAlineacion(data);
          break;
        }
      default:
        break;
    }
  }
  crearAlineacion(data: any) {
    const listaAlineaciones = this.evaluacionesAsignadas
      .map((eva, index) => {
        if (eva.evaluacion[0].nombre === "") return null;
        return {
          detPonderacionId:
            this.datosPonderacion.calificaciones[index].detPonderacionId,
          bbColumnaId: eva.evaluacion[0].id,
          nombreAsignaturaBb: eva.evaluacion[0].nombre,
        };
      })
      .filter((evaluacion: any) => evaluacion !== null);

    let body = {
      instanciaBbId: this.filtrosSeccion.instanciaBBId,
      bbId: this.filtrosSeccion.bbId,
      bbCursoId: this.filtrosSeccion.seccionId,
      ponderacionId: this.filtrosSeccion.ponderacionId,
      alineaciones: listaAlineaciones,
    };
    this._integracionService.crearAlineacionDocente(body).subscribe({
      next: () => {
        data.resultadoServicio = true;
        data.editable = this.seccionEditable;
        data.tipoAlineacion = "Configurar";
        this._router.navigate(["/visualizacion-seccion"], {
          state: {
            data: data,
          },
        });
      },
    });
  }
  confirmarAlineacion(body: IAlineacionBody, data: any) {
    this._integracionService.confirmarAlineacion(body).subscribe({
      next: () => {
        data.resultadoServicio = true;
        data.editable = this.seccionEditable;

        data.tipoAlineacion = "Validar";
        this._router.navigate(["/visualizacion-seccion"], {
          state: {
            data: data,
          },
        });
      },
      error: (error: any) => {
        const detalleError = error.error.details[0];
        this.mensajeError = detalleError.split("/");
        document.getElementById("modal-error")?.click();
      },
    });
  }
  mostrarModal() {
    document.getElementById("modal-confirmar")?.click();
  }
  volverAsignaturasPorPeriodo() {
    this._router.navigate(["/portal-calificacion"], {
      state: {
        data: {
          filtros: this.filtros,
        },
      },
    });
  }
  async getEvaluacionesSeccion(): Promise<void> {
    return new Promise((resolve, reject) => {
    this._integracionService
      .getCalificacionesBlackboard(
        String(this.filtrosSeccion.instanciaBBId),
        this.seccionIdEditar
      )
      .subscribe({
        next: (res: ICalificacionesBlackboard[]) => {
          if (res.length > 0) {
            res.forEach((evaluacion: ICalificacionesBlackboard) => {
              this.evaluaciones.push({ evaluacion: [evaluacion] });
            });
            resolve();
          }
        },
        error: (error) => {
          reject(new Error(error.message));
        }
      });
    });
  }
  editarAlineacion(data: any) {
    const listaAlineaciones = this.evaluacionesAsignadas
      .map((eva, index) => {
        if (eva.evaluacion[0].nombre === "") return null;
        return {
          detPonderacionId:
            this.datosPonderacion.calificaciones[index].detPonderacionId,
          bbColumnaId: eva.evaluacion[0].id,
          nombreAsignaturaBb: eva.evaluacion[0].nombre,
        };
      })
      .filter((evaluacion: any) => evaluacion !== null);

    let body = {
      instanciaBbId: this.filtrosSeccion.instanciaBBId,
      bbId: this.filtrosSeccion.bbId,
      bbCursoId: this.filtrosSeccion.seccionId,
      ponderacionId: this.filtrosSeccion.ponderacionId,
      alineaciones: listaAlineaciones,
    };
    this._integracionService.editarAlineacion(String(this.idAlineacion), body).subscribe({
      next:() => {
        data.resultadoServicio = true;
        data.editable = this.seccionEditable;
        data.tipoAlineacion = "Validar";
        this._router.navigate(["/visualizacion-seccion"], {
          state: {
            data: data,
          },
        });
      },
    })
  }
  redirigirEditar() {
    if (this.vista === 'Validar') {
      this.habilitarEdicion();
    }
  }
}
